export default __webpack_public_path__ + "static/media/cartEmpty.adaccc87.svg";